import React from 'react';
import ImgIconComp from '../../imgcomp';

import GrpMeetingAttendeeList from '../grpMeetingAttendeeList';
import { withTranslation } from 'react-i18next';

class MeetingAttendeePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attendeeList: JSON.parse(JSON.stringify(this.props.attendeeList)) || [],
      showRosterHelp: false,
      showContributeHelp: false,
      attendeeIdList: null,
    };
    this.updateMeetingAccessState = this.updateMeetingAccessState.bind(this);
    this.addFullAttendeeList = this.addFullAttendeeList.bind(this);
    this.addAttendeeToList = this.addAttendeeToList.bind(this);
    this.saveInviteeList = this.saveInviteeList.bind(this);
    this.registerAutoComplete = this.registerAutoComplete.bind(this);
    this.selectAllAttendees = this.selectAllAttendees.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);
    this.closeInviteeList = this.closeInviteeList.bind(this);
  }

  componentDidMount() {
    if (this.props.userTeamList) {
      setTimeout(() => this.registerAutoComplete(this.props.userTeamList), 100);
    }
    // update attendeeIdList state
    const attendIds = [];
    this.state.attendeeList.map((curIte) => {
      attendIds.push(curIte.user_id);
    });
    this.setState({
      attendeeIdList: attendIds,
    });
  }

  updateMeetingAccessState(userId, accessVal) {
    const attendeeListJson = this.state.attendeeList;
    attendeeListJson.map((curIte) => {
      if (curIte.user_id == userId) {
        curIte.access = accessVal;
      }
      return curIte;
    });
    this.setState({
      attendeeList: attendeeListJson,
    });
  }

  addFullAttendeeList(attendeesArr) {
    const attendeeIdLst = this.state.attendeeIdList;
    const _this = this;
    const attendeeListTemp = this.state.attendeeList;

    setTimeout(() => _this.setState({
      attendeeList: [],
    }), 100);
    $.each(attendeesArr, (k, v) => {
      const tempAttendeeArrs = [];
      tempAttendeeArrs.access = '1';
      tempAttendeeArrs.create_at = 0;
      tempAttendeeArrs.id = v.id;
      tempAttendeeArrs.is_admin = '';
      tempAttendeeArrs.meeting_id = '';
      tempAttendeeArrs.picture = v.pic;
      tempAttendeeArrs.team_id = '';
      tempAttendeeArrs.user_id = v.id;
      tempAttendeeArrs.user_name = `${v.name} ${v.lastName}`;
      attendeeListTemp.unshift(tempAttendeeArrs);
      attendeeIdLst.push(v.id);
    });

    setTimeout(() => _this.setState({
      attendeeList: attendeeListTemp,
      attendeeIdList: attendeeIdLst,
    }), 100);
  }

  addAttendeeToList(labelVal, idVal, teamName, userPic) {
    const attendeeIdLst = this.state.attendeeIdList;
    const indVal = $.inArray(idVal, attendeeIdLst);
    // user is already in list, return
    if (indVal > -1) {
      return;
    }

    const tempAttendeeArr = [];
    tempAttendeeArr.access = '1';
    tempAttendeeArr.create_at = 0;
    tempAttendeeArr.id = idVal;
    tempAttendeeArr.is_admin = '';
    tempAttendeeArr.meeting_id = '';
    tempAttendeeArr.picture = userPic;
    tempAttendeeArr.team_id = '';
    tempAttendeeArr.user_id = idVal;
    tempAttendeeArr.user_name = labelVal;

    const _this = this;
    const attendeeListTemp = this.state.attendeeList;

    setTimeout(() => _this.setState({
      attendeeList: [],
    }), 100);
    attendeeListTemp.unshift(tempAttendeeArr);

    attendeeIdLst.push(idVal);

    setTimeout(() => _this.setState({
      attendeeList: attendeeListTemp,
      attendeeIdList: attendeeIdLst,
    }), 100);
  }

  saveInviteeList() {
    const _this = this;
    const meetingInviteeList = $('#meetingInviteePopup').serializeArray();
    if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
      meetingInviteeList.push({ name: 'YII_CSRF_TOKEN', value: $.ajaxSetup().data.YII_CSRF_TOKEN });
    }
    $.post(`${wbConfig.baseUrl}/meeting/updateMeetingAttendees`, meetingInviteeList, (response) => {
      if (response.status == 'ok') {
        if (response.error) {
          // $('.serverError').show().html(res.error);
        } else if (response.meeting_invitees) {
          _this.props.saveMeetingInvitees(_this.props.meetingId, response.meeting_invitees);
        }
      } else {
        // $('.serverError').show().html('Oops something went wrong. Please try again later.');
      }
    });
  }

  registerAutoComplete(usrTmList) {
    const _this = this;
    $(_this.refs.grpMeetingInvite).autocomplete({
      source(request, response) {
        const { term } = request;
        $.ajax({
          url: `${wbConfig.baseUrl}/restapi/meetings/search/users`,
          type: 'GET',
          dataType: 'json',
          data: { term, directOnly: false, teams: true },
        })
          .done((data) => {
            response(data.data.map(row => {
              if(row.type === "team"){
                  return {
                      ...row.data,
                      teamId: row.data.id,
                      label: row.data.name,
                      value: row.data.id
                  };
              }
              else {
                  return {
                      ...row.data, 
                      label: (row.data.firstName || "") + " " + (row.data.lastName || ""),
                      value: row.data.id
                  }
              }
            }));
          });
      },
      minLength: 3,
      select(event, ui) {
        const { teamId } = ui.item;
        const userPic = ui.item.avatarUrl;
        const idVal = ui.item.value;
        const labelVal = ui.item.label;
        const { teamName } = ui.item;
        if (teamId != '0' && teamId) {
          // selected a team, get team members and add to list
          $.ajax({
            url: `${wbConfig.baseUrl}/meeting/getTeamUserDetailsForMeeting`,
            type: 'post',
            data: { teamId: idVal },
          })
            .done((response) => {
              const res = JSON.parse(response);
              const memDet = res.inviteeList;
              _this.addFullAttendeeList(memDet);
            });
        } else {
          // selected a user, add to list
          _this.addAttendeeToList(labelVal, idVal, teamName, userPic);
        }
        $(_this.refs.grpMeetingInvite).val('');
        return false;
      },
      open(event, ui) {
        $(this).data('ui-autocomplete').menu.element.addClass('grp-meeting-inv-list');
      },
      focus(event, ui) {
        return false;
      },
    });
  }

  selectAllAttendees(event) {
    const checkedVal = event.target.checked == true ? 1 : 0;
    const attendeeListJson = this.state.attendeeList;
    attendeeListJson.map((curIte) => {
      curIte.access = checkedVal;
      return curIte;
    });
    this.setState({
      attendeeList: attendeeListJson,
    });
  }

  toggleHelp(actionVal, objVal) {
    this.setState({
      [`${objVal}`]: actionVal,
    });
  }

  closeInviteeList() {
    this.props.showAddAttendeePopupClick();
  }

  render() {
    const { t } = this.props;
    return (
      <div className="addMeetingAttendeeWrapper">
        <form id="meetingInviteePopup" key="12345">
          <div className="grp-meeting-attendee-edit-wrapper">
            <input type="text" placeholder="Type a person or a team's name to add them" ref="grpMeetingInvite" className="grp-meeting-attendee-edit" />
          </div>
          <div className="grp-meeting-roster padTop10">
          {t('Roster')}
            {' '}
            <span onClick={() => this.toggleHelp(true, 'showRosterHelp')}><ImgIconComp class="grp-meeting-roster-help" id="help_img" width="15" height="15" /></span>
            {
              this.state.showRosterHelp
              && (
              <div className="grpMeetingRosterHelp">
                <div className="closeRosterHelp" onClick={() => this.toggleHelp(false, 'showRosterHelp')}>
                  <ImgIconComp id="close" width="10" height="10" />
                </div>
                {t('The roster is who you have invited to the meeting individually or as a member of a team. Don&apos;t want to waste someone&apos;s time with a meeting they don&apos;t need to attend? Deselect them from this list.')}
              </div>
              )
            }
          </div>
          <div className="grp-meeting-select padTop10">
            <input type="checkbox" className="grp-meeting-select-ckbox" id="grp-meeting-select-ckbox" onChange={event => this.selectAllAttendees(event)} />
            <label htmlFor="grp-meeting-select-ckbox">{t('Select All')}</label>
          </div>
          <div className="grp-meeting-add-list">
            {
              (this.state.attendeeList != null && Object.keys(this.state.attendeeList).length)
                ? Object.keys(this.state.attendeeList).map((item, index) => (
                  <GrpMeetingAttendeeList
                    key={index}
                    userPic={this.state.attendeeList[index].picture}
                    userTeamId={this.state.attendeeList[index].team_id}
                    userTeam={this.state.attendeeList[index].team_id}
                    userName={this.state.attendeeList[index].user_name}
                    userId={this.state.attendeeList[index].user_id}
                    userAccess={this.state.attendeeList[index].access}
                    updateMeetingAccessState={this.updateMeetingAccessState}
                  />
                ))
                : ''
              }
          </div>
          <div className="grp-meeting-contribute padTop10">
            <input type="checkbox" name="contributeToAgenda" id="grp-meeting-contribute-ckbox" className="grp-meeting-contribute-ckbox" defaultChecked={this.props.team_contribution == '1'} />
            <label htmlFor="grp-meeting-contribute-ckbox">{t('Ask attendees to contribute to the agenda')}</label>
            <span onClick={() => this.toggleHelp(true, 'showContributeHelp')}>
              <ImgIconComp id="help_img" class="grp-meeting-contribute-help" width="15" height="15" />
            </span>
            <div className="grpMeetingContributeHelpWrapper">
              {
                this.state.showContributeHelp
                && (
                <div className="grpMeetingContributeHelp">
                  <div className="closeRosterHelp" onClick={() => this.toggleHelp(false, 'showContributeHelp')}>
                    <ImgIconComp id="close" width="10" height="10" />
                  </div>
                  {t("Meeting attendees will receive a notification asking them to contribute topics and agenda items to the meeting. If you wish to set the `meeting's` topics and agendas yourself, leave this box unchecked.")}
                </div>
                )
              }
            </div>
          </div>
          <div>
            <div className="gbl-btn meeting-invite-btn dispIB" onClick={this.saveInviteeList}>
            {t('Invite')}
            </div>
            <div className="gbl-btn gbl-btn-cancel dispIB" onClick={this.closeInviteeList} style={{ marginTop: '10px' }}>
            {t('Close')}
            </div>
          </div>
          <input type="hidden" name="selectedMeetingId" value={this.props.meetingId} />
        </form>
      </div>
    );
  }
}
export default withTranslation()(MeetingAttendeePopup);
